import { useDialog } from 'client/modules/app/dialogs/hooks/useDialog';
import { CloseAllPositionsDialog } from 'client/modules/trading/closeAllPositions/CloseAllPositionsDialog';
import { ClosePositionDialog } from 'client/modules/trading/closePosition/ClosePositionDialog';
import { TpSlDialog } from 'client/modules/trading/tpsl/tpslDialog/TpSlDialog';
import { PerpMarginModeDialog } from 'client/pages/PerpTrading/components/PerpMarginModeDialog/PerpMarginModeDialog';

export function PerpDialogs() {
  const { currentDialog } = useDialog();

  return (
    <>
      {currentDialog?.type === 'close_position' && (
        <ClosePositionDialog
          productId={currentDialog.params.productId}
          isoSubaccountName={currentDialog.params.isoSubaccountName}
        />
      )}
      {currentDialog?.type === 'perp_margin_mode' && (
        <PerpMarginModeDialog {...currentDialog.params} />
      )}
      {currentDialog?.type === 'tp_sl' && (
        <TpSlDialog {...currentDialog.params} />
      )}
      {currentDialog?.type === 'close_all_positions' && (
        <CloseAllPositionsDialog />
      )}
    </>
  );
}
